import { usePostHog } from "posthog-js/react";
import { useLocation } from "react-router";
import { useEffect } from "react";
import { getEnvironment } from "shared-utils";

import { createPostHogConfig } from "./posthog-config";

const POSTHOG_KEY = "phc_5Ye2r14imIkan5Ea4FURNXcLdrUt6Ztf6ouzNppU5cn";
export const POSTHOG_DEV_KEY = "phc_1SUEXzRAezj8infuQ9i1DGZdpmrY8uPvXWPeoXjpJDx";

const searchParams = new URLSearchParams(window.location.href);
const distinctID = searchParams.get("distinct_id") ?? undefined;
const sessionID = searchParams.get("session_id") ?? undefined;

export const posthogConfig = createPostHogConfig({
  environment: getEnvironment(),
  productionToken: POSTHOG_KEY,
  developmentToken: POSTHOG_DEV_KEY,
  origin: window.location.origin,
  distinctID,
  sessionID,
});

export function usePostHogPageView() {
  const location = useLocation();
  const posthog = usePostHog();
  useEffect(() => {
    if (posthog) {
      posthog.capture("$pageview");
    }
  }, [location, posthog]);
}
